import { CustomModal } from "Componentes/CustomModal/CustomModal";
import { projects } from "Developers/EstebanCaccin/constants";
import { Container } from "react-bootstrap";
import { CardProjects } from "./CardProjects/CardProjects";

import "./projects.scss";

interface IProjects {
  isOpenProjects: boolean;
  onCloseProjects: () => void;
}

export const Projects = ({ isOpenProjects, onCloseProjects }: IProjects) => {
  return (
    <CustomModal
      className='projects-modal'
      isOpen={isOpenProjects}
      onClose={onCloseProjects}>
      <Container className='projects-container'>
        <h2>Proyectos</h2>
        <div className='projects-grid'>
          {projects.map((e, i) => (
            <CardProjects {...e} key={i} />
          ))}
        </div>
      </Container>
    </CustomModal>
  );
};
